import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=1fb5fa26&scoped=true"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5fa26",
  null
  
)

export default component.exports